import { MangoBlockProps } from "@/types/general";
import { cn } from "@pulsex/utils";
import ImageUI from "../../CustomImage/ImageUI";
import Link from "next/link";
import SectionTitle from "../../shared/Title/SectionTitle";


interface IAuthorDetailsProps extends MangoBlockProps {
    className?: string;
    authorId?: string
}

export default function AuthorDetails({ block, className, authorId }: IAuthorDetailsProps) {
    const widget = block?.getMainWidget();
    if (!widget || !widget?.posts) return;

    return (
        <section className={cn("container mx-auto my-5", className)}>
            {widget.posts?.map((post: any) => (
                <div
                    className="grid grid-cols-12 gap-3 mb-4 lg:mb-9"
                    key={post.id}
                >
                    <Link
                        href={post?.url}
                        className="col-span-3 lg:col-span-12"
                    >
                        <ImageUI data={post} cropSize="square" />
                    </Link>
                    <div className="col-span-8 lg:col-span-12">
                        {post?.tag?.url && (
                            <Link
                                href={post?.tag?.url}
                                className={cn(
                                    "bg-primary rounded py-1 px-6 text-xs font-medium text-white block w-fit mb-2",
                                    "lg:text-[10px] lg:p-1 lg:px-2 lg:mb-1"
                                )}
                            >
                                {post.tag.title}
                            </Link>
                        )}
                        <Link href={post?.url}>
                            <h2 className="text-lg font-bold mb-2 dark:text-white lg:text-base">
                                {post?.title}
                            </h2>
                            <p className="text-base opacity-70 mb-4 dark:text-white">
                                {post?.summary}
                            </p>
                            <p className="text-xs opacity-50 dark:text-white lg:text-xs">
                                {post?.displayDate}
                            </p>
                        </Link>
                    </div>
                </div>
            ))}

                <div className="flex justify-center items-center my-20 lg:my-10">
                    <Link
                        href={`/${authorId}`}
                        className={cn(
                            "px-10 py-2 rounded border border-blue text-blue dark:border-white dark:text-white opacity-50"
                        )}
                    >
                        Show More
                    </Link>
                </div>
        </section>
    );
}
